import React, { forwardRef, useRef } from 'react'
import { Link } from 'react-router-dom';
import { useDropdownFilter } from '../Custom_Hooks/useDropdownFilter';
import { useDropdownKeyboardNavigation } from '../Custom_Hooks/useDropdownKeyboardNavigation';
import { useDropdownScroll } from '../Custom_Hooks/useDropdownScroll';
import { useDispatch } from 'react-redux';
import { closeModal, openModal } from '../../redux/actions/action-creator';


const DropdownYesNo = forwardRef(({ title, state, input_value, input_key, input_id, rawData, data, setData, inputRefs, setSubmitConfirm, style, index, handleDropdownClick }, ref) => {
    const dropdownRef = useRef(null)
    const dispatch = useDispatch();
    const { filteredData } = useDropdownFilter({
        dataList: rawData,
        searchInput: input_value,
        inputRef: ref,
    });
    const { selectedItemIndex, setSelectedItemIndex } = useDropdownKeyboardNavigation({
        items: filteredData,
        state,
        inputRef: ref,
        onItemSelect: (item) => {
            if (input_key === 'per') {
                setData((prevData) => {
                    const updatedData = { ...prevData };
                    updatedData.data_item = updatedData.data_item.map((item_data, i) =>
                        i === index ? {
                            ...item_data,
                            [input_key]: item?.name,
                            [input_id]: item?.id,
                        } : item_data
                    );

                    return updatedData;
                });

                // Navigation logic
                const nextKey = `value${index}`;
                const nextRef = inputRefs?.current?.[nextKey] || inputRefs?.[nextKey]?.current;
                if (nextRef) {
                    setTimeout(() => {
                        nextRef.focus();
                        if (nextRef.setSelectionRange) nextRef.setSelectionRange(0, nextRef.value?.length || 0);
                    }, 50);
                }

                dispatch(closeModal(`${input_key}${index}`))
            } else {
                if (input_key === 'provide_behaviour_opt') {
                    if (item?.name === 'Yes') {
                        dispatch(openModal('behavior'))
                    }
                }
                setData({ ...data, [input_key]: item?.name })

                if (input_key === 'treat_rejection_scrap') {
                    setTimeout(() => {
                        dispatch(closeModal('behavior'))
                    }, 150);
                }
                dispatch(closeModal(input_key))
                if (handleDropdownClick) {
                    handleDropdownClick(input_key, item?.name)
                }
            }
        },
        input_value
    });

    useDropdownScroll({ dropdownRef, selectedItemIndex });

    return (
        <div className={`dropdown_yes_no_list`} style={{ position: "absolute", top: `calc(100% + 5px)`, left: "5px", display: state ? 'block' : 'none', ...style }} >
            <div className='col dropdown_header'>
                {title ? title : 'Yes / No'}
            </div>
            <div id='data'>
                {filteredData?.length > 0 ? (
                    filteredData?.map((key, number) => {
                        const name = key?.name;
                        const index = name?.toLowerCase()?.indexOf(input_value?.toLowerCase());
                        return (
                            <Link
                                className={`list font-weight-bold ${number === selectedItemIndex ? 'selected' : ''}`}
                                id='list'
                                key={number}
                                onClick={() => {
                                    setSelectedItemIndex(number)
                                    setData({ ...data, [input_key]: name })
                                    handleDropdownClick(input_key, name)
                                }}
                            >
                                {index !== -1 ? (
                                    < >
                                        {name.substring(0, index)}
                                        <span style={{ color: 'red' }}>{name.substring(index, index + input_value?.length)}</span>
                                        {name.substring(index + input_value?.length)}
                                    </>
                                ) : (
                                    name
                                )}
                            </Link>
                        );
                    })
                ) : (
                    <p style={{ color: 'red' }}>No matching items found</p>
                )}
            </div>
        </div>
    )
})

export default React.memo(DropdownYesNo)
